import { render, staticRenderFns } from "./PermissionsLayerIcon.vue?vue&type=template&id=ca34f660&"
import script from "./PermissionsLayerIcon.vue?vue&type=script&lang=js&"
export * from "./PermissionsLayerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports